import React, { useState, Component } from "react";
import styled from "styled-components";

import { GradientCard, PossibilityCard } from "../cards/card_box";

import Solutions from "./solution/solutions.js";
import TabContents from "./tab.js";

const PageContainer = styled.body`
  position: relative;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;

  display: flex;
  flex-direction: column;

  align-items: center;
`;

const ResultTopWrapper = styled.div`
  position: relative;
  width: 100%;
  left: 0px;

  margin-top: 20px;

  display: flex;

  align-items: center;
  justify-content: center;
`;

export default class Body extends Component {
  //   console.log(sessionStorage.getItem("adress"));

  constructor() {
    super();
    this.state = { activeTab: 0 };
  }

  menuTabHandler = (id) => {
    this.setState({ activeTab: id });
  };

  render() {
    sessionStorage.removeItem("submitComplete");

    var spaceNum = sessionStorage.getItem("spacenum");
    var weekdayFee = sessionStorage.getItem("weekdayFee");
    var weekendFee = sessionStorage.getItem("weekendFee");
    var dayPassFee = sessionStorage.getItem("dayPassFee");
    var monthPassFee = sessionStorage.getItem("monthPassFee");
    var dayPassNum = sessionStorage.getItem("dayPassNum");
    var monthPassNum = sessionStorage.getItem("monthPassNum");
    var timePassFee = sessionStorage.getItem("timePassFee");

    let profit =
      weekdayFee * 2.5 * 10 * spaceNum * 0.21 +
      weekdayFee * 2.5 * spaceNum * 0.1 * 22 +
      weekendFee * 2.5 * spaceNum * 0.1 * 8 +
      weekdayFee * 2.5 * spaceNum * 0.65 * 22 +
      weekendFee * 2.5 * spaceNum * 0.65 * 8;

    let nowProfit;

    //순서는 (시간, 일, 월)
    if(monthPassNum !== ""){
        if (dayPassNum !== ""){
            if(timePassFee !== ""){
                // (o,o,o)
                nowProfit = 
                monthPassNum * monthPassFee + 
                dayPassFee * dayPassNum * 30 +
                weekdayFee * timePassFee * 22 +
                weekendFee * timePassFee * 8
            }
            else{
                // (x,o,o)
                nowProfit = 
                monthPassNum * monthPassFee + 
                dayPassFee * dayPassNum * 30 +
                weekdayFee * spaceNum * 0.65 * 22 +
                weekendFee * spaceNum * 0.65 * 8
            }
        }
        else if(timePassFee !== ""){
            // (o,x,o)
            nowProfit = 
            monthPassNum * monthPassFee + 
            dayPassFee * spaceNum * 0.1 * 30 +
            weekdayFee * timePassFee * 22 +
            weekendFee * timePassFee * 8
        }
        else{
            //(x,x,o)
            nowProfit = 
            monthPassNum * monthPassFee + 
            dayPassFee * spaceNum * 0.1 * 30 +
            weekdayFee * spaceNum * 0.65 * 22 +
            weekendFee * spaceNum * 0.65 * 8
        
        }
    }
    if(monthPassNum === ""){
        if(dayPassNum !== ""){
            if(timePassFee !== ""){
                // (o,o,x)
                nowProfit = 
                monthPassNum * spaceNum * 0.21 + 
                dayPassFee * dayPassNum * 30 +
                weekdayFee * timePassFee * 22 +
                weekendFee * timePassFee * 8
    
            }
            else{
                // (x,o,x)
                nowProfit = 
                monthPassNum * spaceNum * 0.21 + 
                dayPassFee * dayPassNum * 30 +
                weekdayFee * spaceNum * 0.65 * 22 +
                weekendFee * spaceNum * 0.65 * 8
            }
        }
        else if(timePassFee !== ""){
            // (o,x,x)
            nowProfit = 
            monthPassNum * spaceNum * 0.21 + 
            dayPassFee * spaceNum * 0.1 * 30 +
            weekdayFee * timePassFee * 22 +
            weekendFee * timePassFee * 8
        }
        else{
            //(x,x,x)
            nowProfit = 
            monthPassNum * spaceNum * 0.21 + 
            dayPassFee * spaceNum * 0.1 * 30 +
            weekdayFee * spaceNum * 0.65 * 22 +
            weekendFee * spaceNum * 0.65 * 8
        }
    }
    


    var possibility = Math.floor((profit / nowProfit - 1) * 100);

    profit = profit.toLocaleString("ko-KR");
    nowProfit = nowProfit.toLocaleString("ko-KR");

    return (
      <PageContainer>
        <ResultTopWrapper>
          <GradientCard
            nowProfit={nowProfit}
            profit={profit}
            caption="50,000"
          />
          <PossibilityCard possibility={possibility} />
        </ResultTopWrapper>
        <Solutions></Solutions>
        <TabContents
          menuTabHandler={this.menuTabHandler}
          activeTab={this.state.activeTab}
        />
      </PageContainer>
    );
  }
}
